/*
 * Copyright (c) 2023, WSO2 LLC (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { FormattedMessage } from 'react-intl';
import AuthenticateButton from 'components/ChoreoSystem/Authenticate/AuthenticateButton/AuthenticateButton';
import { ReactComponent as MicrosoftIcon } from 'components/ChoreoSystem/Images/Brands/Microsoft.svg';

interface MicrosoftSignupButtonProps {
  onClick: () => void;
  show: boolean;
}

export default function MicrosoftSignupButton(
  props: MicrosoftSignupButtonProps
) {
  const { onClick, show } = props;
  return show ? (
    <AuthenticateButton
      testId="microsoft-sign-up"
      onClick={onClick}
      startIcon={<MicrosoftIcon fontSize="inherit" />}
    >
      <FormattedMessage
        id="modules.signup.buttons.microsoftSignupButton.withMicrosoft"
        defaultMessage="Continue with Microsoft"
      />
    </AuthenticateButton>
  ) : (
    <></>
  );
}
